module.exports = __webpack_public_path__ + "static/img/tuoyuan_b.88e8d2fc.png";